const ThreeImagePhotoGallery = ({ data }) => {
  if (!data || !data.gallery_images) {
    return (
      <div className="three-image-gallery">
        <div className="gallery-header">
          <h1 className="gallery-title">Photo Gallery</h1>
        </div>
        <div className="gallery-vertical">
          <p>No images available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="three-image-gallery">
      <div className="gallery-header">
        <h2 className="top-header">{data.title}</h2>
        <div className="header-divider"></div>
      </div>

      <div className="gallery-vertical">
        {data.gallery_images.map((image) => (
          <div key={image.id} className="gallery-item-vertical">
            <div className="image-container-vertical">
              <img 
                src={image.url} 
                alt={image.subtext || `Image ${image.id}`}
                className="gallery-image-vertical"
              />
            </div>
            {image.subtext && (
              <p className="image-subtext-vertical">{image.subtext}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThreeImagePhotoGallery;